import { useCallback, useEffect, useState } from 'react';

import AgoraRTC from 'agora-rtc-sdk-ng';

import FieldDeviceSelect from '@/app/components/FieldDeviceSelect';
import { useAppContext } from '../AppContext';
import { EVENTS, gtag } from '@/lib/gtag';


export default function FieldCameraSelect() {
  const { camera, setCameraFacing } = useAppContext();

  const [cameras, setCameras] = useState<MediaDeviceInfo[]>([]);

  const onValueChange = useCallback((deviceId: MediaDeviceInfo['deviceId']) => {
    camera.changeDevice(deviceId);
    // Picking a camera by id says nothing about which way it points, and a
    // device label cannot be trusted to. Rather than keep labelling footage
    // with the direction from before the swap, claim nothing until the flip
    // button — which does know — is used again.
    setCameraFacing(null);

    gtag(EVENTS.CHANGE_DEVICE, { device: 'camera' });
  }, [camera, setCameraFacing]);

  useEffect(function initDevices() {
    if (camera.isPermissionGranted) {
      AgoraRTC.getCameras().then(setCameras);
    }
  }, [camera]);

  return (
    <FieldDeviceSelect
      devices={cameras}
      onValueChange={onValueChange}
      title="Camera"
      value={camera.device} />
  );
}
